import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Snackbar, Alert } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PinterestIcon from '@mui/icons-material/Pinterest';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import ShareIcon from '@mui/icons-material/Share';

export default function ShareSheet({ onShare, disabled }) {
  const [copied, setCopied] = useState(false);

  const siteUrl = 'https://nutscaper.com';
  const shareText = 'Check out my nutscaped photo! 🎭 Create yours free at nutscaper.com';

  const handleNativeShare = async () => {
    if (onShare) {
      const blob = await onShare();
      if (blob && navigator.share) {
        try {
          const file = new File([blob], 'nutscaped-image.png', { type: 'image/png' });
          await navigator.share({
            title: 'My Nutscaped Photo',
            text: shareText,
            files: navigator.canShare && navigator.canShare({ files: [file] }) ? [file] : undefined,
            url: siteUrl,
          });
          return;
        } catch (e) {
          void e;
        }
      }
    }
    try {
      await navigator.clipboard.writeText(siteUrl);
      setCopied(true);
    } catch (e) {
      void e;
    }
  };

  const openShareUrl = (url) => window.open(url, '_blank', 'noopener,noreferrer,width=600,height=500');

  const shareUrls = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + siteUrl)}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(siteUrl)}&description=${encodeURIComponent(shareText)}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(siteUrl)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(siteUrl)}`,
  };

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const buttonSx = {
    color: 'white',
    backgroundColor: 'rgba(255,255,255,0.10)',
    border: '1px solid rgba(255,255,255,0.15)',
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.22)' },
    '&.Mui-disabled': { opacity: 0.4, color: 'white' },
    width: 40,
    height: 40,
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      {isMobile ? (
        <Tooltip title="Share">
          <span>
            <IconButton onClick={handleNativeShare} disabled={disabled} sx={buttonSx} aria-label="share">
              <ShareIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      ) : (
        <>
          <Tooltip title="Share on WhatsApp">
            <span>
              <IconButton onClick={() => openShareUrl(shareUrls.whatsapp)} disabled={disabled} sx={buttonSx} aria-label="share on whatsapp">
                <WhatsAppIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Share on Pinterest">
            <span>
              <IconButton onClick={() => openShareUrl(shareUrls.pinterest)} disabled={disabled} sx={buttonSx} aria-label="share on pinterest">
                <PinterestIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Share on X (Twitter)">
            <span>
              <IconButton onClick={() => openShareUrl(shareUrls.twitter)} disabled={disabled} sx={buttonSx} aria-label="share on twitter">
                <XIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Share on Facebook">
            <span>
              <IconButton onClick={() => openShareUrl(shareUrls.facebook)} disabled={disabled} sx={buttonSx} aria-label="share on facebook">
                <FacebookIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </>
      )}
      <Snackbar
        open={copied}
        autoHideDuration={2500}
        onClose={() => setCopied(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="success" onClose={() => setCopied(false)}>
          Link copied to clipboard!
        </Alert>
      </Snackbar>
    </Box>
  );
}
